<div class="container mt-5">
    <div class="row justify-content-center">
        <div class="col-md-6 text-center">
            <h1 class="display-1">404</h1>
            <h2>Page Not Found</h2>
            <p class="lead">The page you are looking for does not exist.</p>
            <a routerLink="/" class="btn btn-primary">Go to Home</a>
        </div>
    </div>
</div>
